export default "__VITE_ASSET__aLISaAY6NSiJFT$6GdtrfA__$_?as=run__"